import React from 'react';
import { renderFunc, sortFields } from '../common';
import { GridColumn, PayoutContainer } from '../styled-components';
import PropTypes from 'prop-types';

const PayoutScreen = (props) => {
  const { isSingleRowField } = props;
  const allFields = props.payout_fields;
  const sortedFields = sortFields(allFields);
  return (
    <PayoutContainer isSingleRowField={isSingleRowField}>
      {sortedFields.map((item, index) => {
        return <GridColumn key={index}>{renderFunc(item, props)}</GridColumn>;
      })}
    </PayoutContainer>
  );
};

PayoutScreen.propTypes = {
  payout_fields: PropTypes.any,
  isSingleRowField: PropTypes.bool
};

export default PayoutScreen;
